<template>
    <div>
         <!--面包屑导航区域-->
        <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>会员管理</el-breadcrumb-item>
            <el-breadcrumb-item>进出记录</el-breadcrumb-item>
        </el-breadcrumb>
        <!--面包屑导航区域-->
        <!--卡片视图区-->
        <el-card>
            <!--搜索与添加区域-->
            <el-row :gutter="20">
                <el-col :span="24">
                    <el-input placeholder="请输入用户名" clearable v-model="queryInfo.query2" @clear="handleBaseFilterChange" style="width: 300px;padding-right: 10px;">
                        <el-button slot="append" icon="el-icon-search" @click="handleBaseFilterChange"></el-button>
                    </el-input>
                    <el-select v-model="queryInfo.query"  placeholder="请选择门店" @change="handleBaseFilterChange"  style="width: 280px;" clearable  filterable>
                        <el-option v-for="item in storelist" :key="item.id" :label="item.storename" :value="item.id"></el-option>
                    </el-select>
                    <el-select v-model="queryInfo.query1" placeholder="进门/出门" @change="getList" :disabled="!canSelectType" style="width: 120px; margin-left: 10px;" clearable>
                        <el-option label="进门" value="in"></el-option>
                        <el-option label="出门" value="out"></el-option>
                    </el-select>
                    <el-date-picker
                        style="margin-left: 10px;width: 300px;"
                        v-model="customdate"
                        type="daterange"
                        align="right"
                        unlink-panels
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        value-format="yyyy-MM-dd"
                        :clearable="false"
                        :picker-options="pickerOptions" @change="CustomeDate">
                        </el-date-picker>
                    <el-button type="warning" icon="el-icon-warning" @click="openWarningManage" style="margin-left: 10px;">
                        预警人员管理
                    </el-button>
                    <el-button type="primary" icon="el-icon-upload" @click="exportRecords" :loading="exporting" v-permission="'btn:record:export'" style="margin-left: 10px;">
                        导出Excel
                    </el-button>
                </el-col>
            </el-row>
            <br>
            <!--搜索与添加区域-->
            <!--商品列表区域-->
            <el-table :data="list" v-loading="loading" style="width: 100%" stripe size="middle" height="700">
                <el-table-column label="ID" type="index" width="50"></el-table-column>
                <el-table-column label="初始头像" prop="username" width="80">
                  <template slot-scope="scope">
                    <div>
                      <el-popover placement="bottom" width="310" trigger="click">
                        <div style="text-align: center;">
                          <img :src="ossURL+scope.row.username+'.png'" mode="cover" style="width:300px;height: 300px;border-radius: 5px;"/>
                        </div>
                        <img slot="reference" :src="ossURL+scope.row.username+'.png'" style="height: 30px;width: 30px;border-radius: 50%;">
                      </el-popover>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="最新头像" prop="username" width="80">
                  <template slot-scope="scope">
                    <div>
                      <el-popover placement="bottom" width="310" trigger="click">
                        <div style="text-align: center;">
                          <img :src="ossURL+scope.row.username+'now.png'" mode="cover" style="width:300px;height: 300px;border-radius: 5px;"/>
                        </div>
                        <img slot="reference" :src="ossURL+scope.row.username+'now.png'" style="height: 30px;width: 30px;border-radius: 50%;">
                      </el-popover>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="用户名" prop="username" width="120"></el-table-column>
                <el-table-column label="门店名称" prop="storename" width="200" show-overflow-tooltip></el-table-column>
                <el-table-column label="卡名" prop="cardname" width="300" show-overflow-tooltip></el-table-column>
                <el-table-column label="状态" prop="type" width="100">
                    <template slot-scope="scope">
                        <span>
                            <el-tag v-if="scope.row.type=='in'" type="success">进门</el-tag>
                            <el-tag v-else-if="scope.row.type=='out'" type="danger">出门</el-tag>
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="时间" prop="recordtime" width="180"></el-table-column>
            </el-table>
            <!--商品列表区域-->
             <!--分页区域-->
             <br>
            <div align="center">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="queryInfo.pagenum" :page-sizes="[20,50,500,1000]"  :page-size="queryInfo.pagesize"
                layout="total, sizes, prev, pager, next" :total="total">
                </el-pagination>
            </div>
            <!--分页区域-->
        </el-card>

        <!-- 预警人员管理对话框 -->
        <el-dialog title="预警人员管理" :visible.sync="warningDialogVisible" width="70%" top="5vh">
            <el-button type="primary" icon="el-icon-plus" @click="addWarningPerson" style="margin-bottom: 20px;">
                添加预警人员
            </el-button>
            
            <el-table :data="warningList" border stripe style="width: 100%">
                <el-table-column label="ID" prop="id" width="60"></el-table-column>
                <el-table-column label="手机号" prop="username" width="120"></el-table-column>
                <el-table-column label="昵称" prop="nickname" width="100"></el-table-column>
                <el-table-column label="适用店铺" width="200">
                    <template slot-scope="scope">
                        <el-tag v-if="!scope.row.storeId" type="success">全部店铺</el-tag>
                        <span v-else>{{ scope.row.storeName }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="预警原因" prop="reason" show-overflow-tooltip></el-table-column>
                <el-table-column label="级别" width="80" align="center">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.level === 1" type="info" size="small">普通</el-tag>
                        <el-tag v-else-if="scope.row.level === 2" type="warning" size="small">重要</el-tag>
                        <el-tag v-else type="danger" size="small">紧急</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="预警次数" prop="warningCount" width="100" align="center"></el-table-column>
                <el-table-column label="最后预警时间" prop="lastWarningTime" width="180"></el-table-column>
                <el-table-column label="最后预警店铺" prop="lastWarningStoreName" width="150" show-overflow-tooltip></el-table-column>
                <el-table-column label="状态" width="80" align="center">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.status === 1" type="success" size="small">启用</el-tag>
                        <el-tag v-else type="info" size="small">禁用</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="100" fixed="right" align="center">
                    <template slot-scope="scope">
                        <el-button type="danger" size="mini" @click="deleteWarningPerson(scope.row.id)">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>

        <!-- 添加预警人员对话框 -->
        <el-dialog title="添加预警人员" :visible.sync="addWarningDialogVisible" width="500px">
            <el-form :model="warningForm" :rules="warningFormRules" ref="warningFormRef" label-width="100px">
                <el-form-item label="手机号" prop="username">
                    <el-input v-model="warningForm.username" placeholder="请输入手机号"></el-input>
                </el-form-item>
                <el-form-item label="昵称" prop="nickname">
                    <el-input v-model="warningForm.nickname" placeholder="请输入昵称（可选）"></el-input>
                </el-form-item>
                <el-form-item label="适用店铺" prop="storeId">
                    <el-select v-model="warningForm.storeId" placeholder="请选择店铺" filterable style="width: 100%;">
                        <el-option v-for="item in storelist" :key="item.id" :label="item.storename" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="预警原因" prop="reason">
                    <el-input type="textarea" v-model="warningForm.reason" :rows="3" placeholder="请输入预警原因"></el-input>
                </el-form-item>
                <el-form-item label="预警级别" prop="level">
                    <el-radio-group v-model="warningForm.level">
                        <el-radio :label="1">普通</el-radio>
                        <el-radio :label="2">重要</el-radio>
                        <el-radio :label="3">紧急</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <span slot="footer">
                <el-button @click="addWarningDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitWarningPerson">确 定</el-button>
            </span>
        </el-dialog>

        <!-- 预警弹窗 -->
        <el-dialog
            :visible.sync="warningAlertVisible"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :show-close="false"
            width="550px"
            center>
            <div slot="title" style="text-align: center;">
                <i class="el-icon-warning" :style="{color: warningColor, fontSize: '60px'}"></i>
                <h2 :style="{margin: '10px 0', color: warningColor}">预警提示</h2>
            </div>
            
            <div style="padding: 20px; font-size: 16px; line-height: 2;">
                <p><strong>预警人员：</strong>{{ currentWarning.username }} <span v-if="currentWarning.nickname">({{ currentWarning.nickname }})</span></p>
                <p><strong>进入店铺：</strong>{{ currentWarning.storeName }}</p>
                <p><strong>进入时间：</strong>{{ currentWarning.recordTime }}</p>
                <p><strong>预警原因：</strong><span style="color: #F56C6C; font-weight: bold;">{{ currentWarning.reason }}</span></p>
            </div>
            
            <span slot="footer">
                <el-button type="primary" size="large" @click="confirmWarning" style="width: 200px;">
                    <i class="el-icon-check"></i> 我已知晓
                </el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import axios from "axios";
import { saveAs } from "file-saver";
import { Loading } from "element-ui";

export default {
    data() {
        return{
          loading: false,
          ossURL: this.ossURL,
            pickerOptions: {
                shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                    picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一个月',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                    picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近三个月',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                    picker.$emit('pick', [start, end]);
                    }
                }],
                disabledDate(time) {
                  return time.getTime() > Date.now()
                }
            },
            customdate: [],
            queryInfo: {
                query: '',
                query1:'',
                query2:'',
                startdate:'',
                enddate:'',
                pagenum: 1,
                pagesize: 20
            },
            total:0,
            list: [],
            storelist:[],
            exclelist:[],
            exporting: false,
            excel_fields: {  //导出Excel表格的表头设置
                '门店名称': 'storename',
                '用户名': 'username',
                // '加盟商':'name',
                '内容':'content',
                '收入/支出':'sign',
                '收支金额': 'amount',
                '交易类型': 'type',
                '日期': 'adddate'
            },
            // 预警相关
            warningDialogVisible: false,
            addWarningDialogVisible: false,
            warningAlertVisible: false,
            warningList: [],
            warningForm: {
                username: '',
                nickname: '',
                storeId: null,
                storeName: '',
                reason: '',
                level: 1,
                status: 1,
                createBy: 'mowei'
            },
            warningFormRules: {
                username: [
                    { required: true, message: '请输入手机号', trigger: 'blur' },
                    { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
                ],
                storeId: [
                    { required: true, message: '请选择店铺', trigger: 'change' }
                ],
                reason: [
                    { required: true, message: '请输入预警原因', trigger: 'blur' }
                ]
            },
            currentWarning: {},
            warningAudio: null
        }

    },
    created() {
         this.initDefaultDate()
         this.getList()
         this.getStoreList()
    },
    mounted() {
        // 监听WebSocket消息
        if (window.ws) {
            window.ws.addEventListener('message', this.handleWebSocketMessage)
        }
        
        // 请求浏览器通知权限
        if ('Notification' in window && Notification.permission === 'default') {
            Notification.requestPermission()
        }
    },
    beforeDestroy() {
        // 移除WebSocket监听
        if (window.ws) {
            window.ws.removeEventListener('message', this.handleWebSocketMessage)
        }
    },
    watch: {
        canSelectType(val) {
            if (!val && this.queryInfo.query1) {
                this.queryInfo.query1 = ''
                this.getList()
            }
        }
    },
    computed: {
        canSelectType() {
            return !!(this.queryInfo.query || this.queryInfo.query2)
        },
        warningColor() {
            if (!this.currentWarning.level) return '#E6A23C'
            switch (this.currentWarning.level) {
                case 1: return '#909399'  // 普通-灰色
                case 2: return '#E6A23C'  // 重要-橙色
                case 3: return '#F56C6C'  // 紧急-红色
                default: return '#E6A23C'
            }
        }
    },
    methods:{
        // 导出进出记录
        exportRecords() {
            if (!this.queryInfo.startdate || !this.queryInfo.enddate) {
                this.$message.warning('请选择日期范围')
                return
            }
            const start = new Date(this.queryInfo.startdate)
            const end = new Date(this.queryInfo.enddate)
            const diffDays = Math.floor((end - start) / (1000 * 60 * 60 * 24))
            if (diffDays > 31) {
                this.$message.error('日期范围不能超过31天')
                return
            }
            if (!this.queryInfo.query) {
                this.$message.warning('请选择门店')
                return
            }
            this.exporting = true
            let downloadLoadingInstance = Loading.service({
                text: "正在下载数据，请稍候",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            })
            axios
                .post("/recordlist/export", null, {
                    headers: { "Content-Type": "application/x-www-form-urlencoded" },
                    responseType: "blob",
                    params: {
                        query: this.queryInfo.query,
                        query1: this.queryInfo.query1,
                        query2: this.queryInfo.query2,
                        startdate: this.queryInfo.startdate,
                        enddate: this.queryInfo.enddate
                    }
                })
                .then(async (data) => {
                    this.exporting = false
                    const isBlob = data.data.type !== "application/json"
                    if (isBlob) {
                        const blob = new Blob([data.data])
                        saveAs(blob, `进出记录_${new Date().getTime()}.xlsx`)
                    } else {
                        this.$message.error("导出进出记录失败")
                    }
                    downloadLoadingInstance.close()
                })
                .catch((r) => {
                    this.exporting = false
                    console.error(r)
                    this.$message.error("下载文件出现错误，请联系管理员！")
                    downloadLoadingInstance.close()
                })
        },
        async getStoreList(){
            const { data: res } = await this.$http.get('store/')
            this.storelist = res.data
        },
        handleBaseFilterChange() {
            if (!this.queryInfo.query && !this.queryInfo.query2) {
                this.queryInfo.query1 = ''
            }
            this.getList()
        },
        async getList() {
          if (!this.queryInfo.startdate || !this.queryInfo.enddate) {
            this.$message.warning('请选择日期范围')
            return
          }
          this.loading = true
            const { data:res } = await this.$http.get('recordlist/',{ params: this.queryInfo })
          this.loading = false
            if(res.status == 1){
                this.total = res.data.totalCount;
                this.list = res.data.list.map(v => {
                //在返回的数据里增加一条数据
                // console.log(v.fields)
                return v.fields
                })
            }
            for (let index = 0; index < res.data.list.length; index++) {
                this.list[index].id= res.data.list[index].pk;
            }
        },
        initDefaultDate() {
          const end = new Date()
          const start = new Date()
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
          const formatDate = (d) => {
            const y = d.getFullYear()
            const m = String(d.getMonth() + 1).padStart(2, '0')
            const day = String(d.getDate()).padStart(2, '0')
            return y + '-' + m + '-' + day
          }
          this.customdate = [formatDate(start), formatDate(end)]
          this.queryInfo.startdate = this.customdate[0]
          this.queryInfo.enddate = this.customdate[1]
        },
        handleSizeChange(newSize){
          // console.log(newSize)
           this.queryInfo.pagesize = newSize
           this.getList()
       },
       handleCurrentChange(newPage){
          // console.log(newPage)
           this.queryInfo.pagenum = newPage
           this.getList()
       },
       CustomeDate(){
            console.log(this.customdate);
            if(this.customdate == null || !this.customdate.length){
                // 日期清空时恢复默认近7天
                this.initDefaultDate()
            }else{
                this.queryInfo.startdate = this.customdate[0]
                this.queryInfo.enddate = this.customdate[1]
            }
            this.getList()
        },
        // ========== 预警相关方法 ==========
        handleWebSocketMessage(event) {
            try {
                const message = JSON.parse(event.data)
                
                if (message.type === 'warningAlert') {
                    this.showWarningAlert(message.data)
                }
            } catch (error) {
                console.error('WebSocket消息解析失败:', error)
            }
        },
        showWarningAlert(warning) {
            this.currentWarning = warning
            this.warningAlertVisible = true
            
            // 播放预警音效（如果有）
            if (this.warningAudio) {
                this.warningAudio.play().catch(e => console.log('音效播放失败:', e))
            }
            
            // 浏览器通知
            if ('Notification' in window && Notification.permission === 'granted') {
                new Notification('预警提示', {
                    body: `${warning.username} 进入 ${warning.storeName}`,
                    icon: '/static/warning-icon.png',
                    requireInteraction: true
                })
            }
            
            console.warn('⚠️ 预警人员进店:', warning)
        },
        async confirmWarning() {
            try {
                const { data: res } = await this.$http.post('warning/confirm', {
                    id: this.currentWarning.id,
                    confirmBy: window.sessionStorage.getItem('admin_token') || 'mowei'
                })
                
                if (res.status === 0) {
                    this.warningAlertVisible = false
                    this.$message.success('已确认')
                } else {
                    this.$message.error(res.message || '确认失败')
                }
            } catch (error) {
                console.error('确认预警失败:', error)
                this.$message.error('确认失败')
            }
        },
        async openWarningManage() {
            this.warningDialogVisible = true
            await this.loadWarningList()
        },
        async loadWarningList() {
            try {
                const { data: res } = await this.$http.get('warning/person/list')
                if (res.status === 0) {
                    this.warningList = res.data || []
                } else {
                    this.$message.error(res.message || '查询失败')
                }
            } catch (error) {
                console.error('查询预警人员列表失败:', error)
                this.$message.error('查询失败')
            }
        },
        addWarningPerson() {
            // 重置表单
            this.warningForm = {
                username: '',
                nickname: '',
                storeId: null,
                storeName: '',
                reason: '',
                level: 1,
                status: 1,
                createBy: 'mowei'
            }
            
            this.addWarningDialogVisible = true
            
            // 清空表单验证
            this.$nextTick(() => {
                if (this.$refs.warningFormRef) {
                    this.$refs.warningFormRef.clearValidate()
                }
            })
        },
        async submitWarningPerson() {
            try {
                // 表单验证
                await this.$refs.warningFormRef.validate()
                
                // 如果选择了店铺，设置店铺名称
                if (this.warningForm.storeId) {
                    const store = this.storelist.find(s => s.id === this.warningForm.storeId)
                    if (store) {
                        this.warningForm.storeName = store.storename
                    }
                }
                
                const { data: res } = await this.$http.post('warning/person/add', this.warningForm)
                
                if (res.status === 0) {
                    this.$message.success('添加成功')
                    this.addWarningDialogVisible = false
                    await this.loadWarningList()
                } else {
                    this.$message.error(res.message || '添加失败')
                }
            } catch (error) {
                if (error !== false) {  // 不是表单验证错误
                    console.error('添加预警人员失败:', error)
                    this.$message.error('添加失败')
                }
            }
        },
        async deleteWarningPerson(id) {
            try {
                const confirm = await this.$confirm('确定删除该预警人员？', '提示', {
                    type: 'warning'
                }).catch(() => false)
                
                if (!confirm) return
                
                const { data: res } = await this.$http.post(`warning/person/delete/${id}`)
                
                if (res.status === 0) {
                    this.$message.success('删除成功')
                    await this.loadWarningList()
                } else {
                    this.$message.error(res.message || '删除失败')
                }
            } catch (error) {
                console.error('删除预警人员失败:', error)
                this.$message.error('删除失败')
            }
        }
    }
}
</script>
<style scoped>
    .cardcss{
        margin: 5px auto ;
        width: 100%;
    }
    .el-breadcrumb{
        width: 100%;
    }
    el-table__row>td {
    border: none;
    }

    .el-table::before {
        height: 0px;
    }

</style>
